import { createApp } from 'vue'
import App from './App.vue'
import route from './router'
import store from './store'
import './permission'
import InfiniteScroll from "infinite-loading-vue3"

import InfiniteLoading from 'vue-infinite-loading'
import toVue3 from 'vue-2-3/to-vue-3'
import * as Vue3 from 'vue'
toVue3.register(Vue2, Vue3);
import Vue2 from 'vue2'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import CONSTANTS from "@/constants"
import VueSocketIO from 'vue-3-socket.io'
import { getAccessToken } from '@/auth'
import vClickOutside from "click-outside-vue3"
import './registerServiceWorker'
import './firebase'
// Import component
import Loading from 'vue3-loading-overlay';
// Import stylesheet
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
// import VueAwesomeSwiper from 'vue-awesome-swiper'


const infiniteLoading = toVue3(InfiniteLoading, {
    slots: {
        noResults: 'No results message',
    },
})

const app = createApp(App)

// app.config.globalProperties.$messaging = firebaseMessaging
app.use(route)
app.use(store)
app.use(vClickOutside)
app.use(VueGoogleMaps, {
    load: {
        key: CONSTANTS.GOOGLE_API_KEY,
    },
    autobindAllEvents: true
})
if (getAccessToken()) {
    app.use(new VueSocketIO({
        debug: true,
        connection: process.env.VUE_APP_SOCKET,
        options: {
            query: {
                token: getAccessToken(),
                debug: 'dev',
            },
        } //Optional options
    }))
}
app.component('infinite-scroll', InfiniteScroll)
app.component('infinite-loading', infiniteLoading)
app.component('loading', Loading)

app.mount('#app')